/**
 * These functions are used on logged-out-home-page package to get non trivial
 * data strings used for FA and GTM logging.  These where added as part of refactoring to
 * remove `log` and `tracking` layers. The approach is to invoke FA and GTM directly from onClick events.
 *
 * @ricardo-cabret
 */

/**
 *
 * @param name - Feature Name
 *
 * @return Component string used for logging
 */
export const getFAComponentStringViaFeatureName = (name: string): string => {
  switch (name) {
    case 'player':
      return 'video_player';
    case 'live':
      return 'live_streaming';
    default:
      return name;
  }
};

/**
 *
 * @param name - Feature Name
 * @param learnMore
 *
 * @return GTM Event Name
 */
export const getGTMEventStringViaFeatureName = (name: string, learnMore = false): string =>
  `lohp_${getFAComponentStringViaFeatureName(name)}_${learnMore ? 'learn_more' : 'compare_plans'}`;
